export function getLazyImageObserver(): IntersectionObserver {
  return new window.IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const element = entry.target
        if (!(element instanceof HTMLImageElement)) {
          return
        }

        const dataSrc = element.dataset.src
        if (entry.isIntersecting && dataSrc !== undefined) {
          element.src = dataSrc
          delete element.dataset.src
        }
      })
    },
    {
      rootMargin: '0px 0px 100px 0px',
    },
  )
}
